
import axios from 'axios'

export default {

    init() {
        const form   = document.getElementById('industry-form')
        const submit = document.getElementById('industry-submit')

        if (!form) {
            return
        }

        form.addEventListener('submit', (e) => {
            e.preventDefault()
        })

        submit.addEventListener('click', e => {
            e.preventDefault()
            this.postForm()
        })
    },

    postForm() {
        axios.post('/v2018/industry-request', this._formData())
            .then(response => {
                // remove all errors
                this._addErrors([])
                const form = document.getElementById('industry-form')
                const msg  = document.getElementById('form-success-message')
                form.style.display = 'none'
                msg.style.display = 'block'
            })
            .catch(error => {
                this._addErrors(Object.keys(error.response.data))
            })
    },

    _allFieldNames() {
        return [
            'name',
            'nachname',
            'jobtitel',
            'firma',
            'brands',
            'telefon',
            'email'
        ]
    },

    _formData() {
        const data = {}
        this._allFieldNames().forEach(field => {
            data[field] = this._value(field)
        })
        return data
    },

    _field(name) {
        return document.getElementById(name)
    },

    _value(name) {
        return this._field(name).value
    },

    _addErrors(errors) {
        this._allFieldNames().forEach(field => {
            this._field(field).classList.remove('error')
        })
        errors.forEach(error => {
            this._field(error).classList.add('error')
        })
    }

}